<template>
  <b-row>
    <b-col>
      <base-tree
        :key="`baseTree-${baseTreeState}`"
        :items="items"
        :offset="offset"
        :additional-offset="additionalOffset"
        index="main"
        class="tree__learning-outcome"
      ></base-tree>
    </b-col>

    <modal-create-or-update-ultimate-learning-outcome
      :learning-unit-id="learningUnitId"
      :ultimate-learning-outcome="learningOutcome"
      :show.sync="showModalUltimateLearningOutcome"
      @update="onUltimateLearningOutcomeUpdated"
    />

    <modal-create-or-update-sub-learning-outcome
      :ultimate-learning-outcome="learningOutcome"
      :sub-learning-outcome="subLearningOutcomeData"
      :show.sync="showModalSubLearningOutcome"
      @update="onSubLearningOutcomeUpdated"
    />

    <modal-create-or-update-criteria
      :ultimate-learning-outcome="learningOutcome"
      :criteria="criteriaData"
      :show.sync="showModalCriteria"
      @update="onCriteriaUpdated"
    />

    <modal-delete-sub-learning-outcome
      :ultimate-learning-outcome="learningOutcome"
      :sub-learning-outcome="subLearningOutcomeData"
      :show.sync="showModalDeleteSubLearningOutcome"
      @onSubLearningOutcomeDeleted="onSubLearningOutcomeDeleted"
    />

    <modal-delete-criteria
      :ultimate-learning-outcome="learningOutcome"
      :criteria="criteriaData"
      :show.sync="showModalDeleteCriteria"
      @onCriteriaDeleted="onCriteriaDeleted"
    />
  </b-row>
</template>

<script>
import BaseTree from '@/components/base-components/BaseTree';
import UltimateLearningOutcomeSubTree from './UltimateLearningOutcomeSubTree';
import SubLearningOutcomeSubTree from './SubLearningOutcomeSubTree';
import CriteriaSubTree from '@/components/Criteria/CriteriaSubTree';
import LearningOutcome from '@/models/LearningOutcome';
import Criteria from '@/models/Criteria';
import Post from '@/models/Post';
import ModalCreateOrUpdateCriteria from './ModalCreateOrUpdateCriteria';
import ModalCreateOrUpdateUltimateLearningOutcome from './ModalCreateOrUpdateUltimateLearningOutcome';
import ModalCreateOrUpdateSubLearningOutcome from './ModalCreateOrUpdateSubLearningOutcome';
import ModalDeleteCriteria from './ModalDeleteCriteria';
import ModalDeleteSubLearningOutcome from './ModalDeleteSubLearningOutcome';
export default {
  components: {
    BaseTree,
    ModalCreateOrUpdateCriteria,
    ModalCreateOrUpdateSubLearningOutcome,
    ModalDeleteCriteria,
    ModalDeleteSubLearningOutcome,
    ModalCreateOrUpdateUltimateLearningOutcome
  },
  props: {
    learningUnitId: {
      type: [String, Number],
      required: true
    },

    learningOutcome: {
      type: LearningOutcome,
      required: true
    },

    criteria: {
      type: Object,
      default: null
    },

    isSubmissionPass: {
      type: [Number, Boolean],
      default: false
    },

    mapCriterionPost: {
      type: Object,
      default: null
    },

    mapLearningOutcomeCriterion: {
      type: Object,
      default: null
    },

    grantCertMode: {
      type: [Number, Boolean],
      default: false
    },

    sectionId: {
      type: [String, Number],
      default: null
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },
    modalMode: {
      type: [Number, Boolean],
      default: false
    },
    hideShift: {
      type: Boolean,
      default: false
    },
    hideCreateUltimateLo: {
      type: Boolean,
      default: false
    },
    hideCreateCriteriaUltimateLo: {
      type: Boolean,
      default: false
    },
    hideCreateCriteriaSubLo: {
      type: Boolean,
      default: false
    },
    hideCreateAssessmentCriteria: {
      type: Boolean,
      default: true
    },
    hideAssessmentCriteria: {
      type: Boolean,
      default: true
    },
    hideSetting: {
      type: Boolean,
      default: false
    },
    hideDescription: {
      type: Boolean,
      default: false
    },
    showOnlyHasCriteria: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModalCriteria: false,
      showModalSubLearningOutcome: false,
      showModalUltimateLearningOutcome: false,
      showModalDeleteCriteria: false,
      showModalDeleteSubLearningOutcome: false,
      subLearningOutcomeData: null,
      criteriaData: null,
      offset: {
        main: 0
      },
      additionalOffset: {
        main: []
      },
      additionalIndices: {},
      criteriaIndices: {},
      activeState: {},
      baseTreeState: 1,
      lastParentIndex: null
    };
  },

  computed: {
    items() {
      return this.extractUltimateLearningOutcomeTree(this.learningOutcome);
    },

    properties() {
      let { properties = '{}' } = this.learningOutcome;

      return JSON.parse(properties);
    },

    order() {
      const { order = [] } = this.properties;

      return order;
    },

    filteredOrder() {
      let { order = [], criteria = {}, grantCertMode = false } = this;

      if (criteria && grantCertMode) {
        order = order
          .map((orderRecord) => {
            if (orderRecord.model === 'criterias') {
              if (!criteria[orderRecord.id]) {
                return null;
              }
            } else {
              let { children = [], ...orderRecordProps } = orderRecord;

              children = children.filter(
                (child) => child.model === 'criterias' && criteria[child.id]
              );

              if (!children.length) {
                return null;
              } else {
                orderRecord = {
                  ...orderRecordProps,
                  children
                };
              }
            }

            return orderRecord;
          })
          .filter(Boolean);
      }

      return order;
    }
  },

  methods: {
    extractRootCriteriaTree(criterion, index) {
      const self = this;

      const {
        sectionId,
        disabled,
        hideShift,
        hideSetting,
        hideCreateAssessmentCriteria,
        hideAssessmentCriteria,
        hideCreateUltimateLo,
        hideCreateCriteriaUltimateLo,
        hideDescription,
        grantCertMode,
        criteria,
        lastParentIndex
      } = this;

      let isLastCritieriaIndex = index === lastParentIndex;

      let isObservedOffset =
        isLastCritieriaIndex &&
        hideCreateAssessmentCriteria &&
        hideCreateUltimateLo &&
        hideCreateCriteriaUltimateLo; // is last criteria of ultimate lo && hide create assessment criteria button

      const isCriteriaPass =
        criteria && criteria[criterion.id] && criteria && criteria[criterion.id].pass;

      const node = {
        index,
        title: 'Criteria',
        subTitle: criterion.title,
        description: `
                    <p><b style="margin-right: 1rem;">Pass</b>&nbsp;— <span class="text__pass-criteria text-pre-wrap">${criterion.pass_criterion}</span></p>
                    <p><b>Not Yet</b>  — <span class="text__not-yet-criteria text-pre-wrap">${criterion.not_yet_criterion}</span></p>
                  `,
        itemClass: {
          'card__criteria-card': true
        },
        titleClass: {
          'text-muted': grantCertMode ? !isCriteriaPass : false
        },
        subTitleClass: {
          'text__criteria-title': true,
          'text-muted': grantCertMode ? !isCriteriaPass : false
        },
        descriptionClass: {
          'ml-3': true
        },
        togglerLabel: 'passing Criteria',
        togglerActiveClass: 'button__hide-criteria',
        togglerInActiveClass: 'button__show-criteria',
        hideShift,
        hideSetting,
        hideDescription,
        isObservedOffset,
        parentIndex: null,
        activeState: this.activeState,
        disableShiftUp: disabled || index === 0,
        disableShiftDown: disabled || isLastCritieriaIndex,
        disabled,
        icon: grantCertMode
          ? {
              branch: hideCreateAssessmentCriteria && hideAssessmentCriteria,
              faIcon: isCriteriaPass ? 'check-circle' : 'clock',
              variant: isCriteriaPass ? 'success' : 'warning',
              color: isCriteriaPass ? 'success' : 'warning',
              className: isCriteriaPass
                ? {
                    'bg-50-icon__success': true
                  }
                : { 'bg-50-icon__warning': true }
            }
          : {
              branch: hideCreateAssessmentCriteria && hideAssessmentCriteria,
              text: 'C',
              variant: 'dark'
            },
        on: {
          edit() {
            if (criterion) {
              self.criteriaData = criterion;

              self.showModalCriteria = true;
            }
          },
          delete() {
            if (criterion) {
              self.criteriaData = criterion;

              self.showModalDeleteCriteria = true;
            }
          },
          'shift:up': () => {
            self.shiftUp(index);
          },

          'shift:down': () => {
            self.shiftDown(index);
          },

          'update:state': ({ offset, isActive } = {}) => {
            this.$set(this.offset, `parent_${index}`, offset);

            if (index === this.lastParentIndex) {
              this.$set(this.offset, 'main', offset);
            }

            if (isActive !== undefined) {
              this.$set(this.activeState, `parent_${index}`, isActive);
            }
          }
        }
      };

      if (hideCreateAssessmentCriteria && hideAssessmentCriteria) {
        return node;
      } else {
        let items = [node];

        if (!hideAssessmentCriteria) {
          const assessments = this.extractAssessment(criterion, index, isObservedOffset);

          items = items.concat(assessments);
        }

        if (!hideCreateAssessmentCriteria) {
          items.push({
            component: CriteriaSubTree,
            componentProps: {
              sectionId,
              criterion,
              disabled: disabled,
              hideCreateAssessmentCriteria
            },
            icon: {
              branch: true
            }
          });
        }

        return {
          component: BaseTree,
          componentProps: {
            class: { 'is-branch': true, criteria: true, criteria__root: true },
            items,
            offset: this.offset,
            additionalOffset: this.additionalOffset,
            index: `parent_${index}`
          },
          icon: {
            branch: true
          }
        };
      }
    },

    extractSubLoCriteriaTree(criterion, index, maxIndex, parentIndex) {
      const self = this;

      const {
        sectionId,
        disabled,
        hideShift,
        hideSetting,
        hideCreateAssessmentCriteria,
        hideAssessmentCriteria,
        hideCreateCriteriaSubLo,
        hideDescription,
        grantCertMode,
        criteria,
        hideCreateUltimateLo,
        hideCreateCriteriaUltimateLo
      } = this;

      const targetCriteriaIndex =
        this.additionalIndices[`parent_${parentIndex}_criteria_${criterion.id}`];

      const isLastCritieriaIndex = index === maxIndex;

      const isLastCriteriaOfLastSubLoOfUltimateLo =
        this.lastParentIndex !== null && parentIndex === this.lastParentIndex; // is criteria of the last sub lo of ultimate lo

      let isnotLastCriteriaOfLastSubLo =
        this.lastParentIndex !== null &&
        parentIndex !== this.lastParentIndex &&
        isLastCritieriaIndex;

      const isObservedOffset =
        (isLastCritieriaIndex && hideCreateCriteriaSubLo) ||
        (isLastCriteriaOfLastSubLoOfUltimateLo &&
          hideCreateAssessmentCriteria &&
          hideCreateUltimateLo &&
          hideCreateCriteriaUltimateLo);

      const isCriteriaPass =
        criteria && criteria[criterion.id] && criteria && criteria[criterion.id].pass;

      const node = {
        index,
        title: 'Criteria',
        subTitle: criterion.title,
        description: `
                    <p><b style="margin-right: 1rem;">Pass</b>&nbsp;— <span class="text__pass-criteria text-pre-wrap">${criterion.pass_criterion}</span></p>
                    <p><b>Not Yet</b>  — <span class="text__not-yet-criteria text-pre-wrap">${criterion.not_yet_criterion}</span></p>
                  `,
        itemClass: {
          'card__criteria-card': true
        },
        titleClass: {
          'text-muted': grantCertMode ? !isCriteriaPass : false
        },
        subTitleClass: {
          'text__criteria-title': true,
          'text-muted': grantCertMode ? !isCriteriaPass : false
        },
        descriptionClass: {
          'ml-3': true
        },
        togglerLabel: 'passing Criteria',
        togglerActiveClass: 'button__hide-criteria',
        togglerInActiveClass: 'button__show-criteria',
        hideShift,
        hideSetting,
        hideDescription,
        isObservedOffset,
        parentIndex: `parent_${parentIndex}`,
        activeState: this.activeState,
        disableShiftUp: disabled || index === 0,
        disableShiftDown: disabled || isLastCritieriaIndex,
        disabled,
        icon: grantCertMode
          ? {
              branch: hideCreateAssessmentCriteria && hideAssessmentCriteria,
              faIcon: isCriteriaPass ? 'check-circle' : 'clock',
              variant: isCriteriaPass ? 'success' : 'warning',
              color: isCriteriaPass ? 'success' : 'warning',
              className: isCriteriaPass
                ? {
                    'bg-50-icon__success': true
                  }
                : { 'bg-50-icon__warning': true }
            }
          : {
              branch: hideCreateAssessmentCriteria && hideAssessmentCriteria,
              text: 'C',
              variant: 'dark'
            },
        on: {
          edit() {
            if (criterion) {
              self.criteriaData = criterion;
              self.showModalCriteria = true;
            }
          },
          delete() {
            if (criterion) {
              self.criteriaData = criterion;
              self.showModalDeleteCriteria = true;
            }
          },
          'shift:up': () => {
            self.shiftUp(parentIndex, index);
          },

          'shift:down': () => {
            self.shiftDown(parentIndex, index);
          },

          'update:state': ({ offset, isActive } = {}) => {
            // if (hideCreateCriteriaSubLo) {
            // let isnotLastCriteriaOfLastSubLo =
            //   this.lastParentIndex !== null &&
            //   parentIndex !== this.lastParentIndex &&
            //   isLastCritieriaIndex;

            let parentOffset = offset;

            let actionOffset = 0;

            if (
              isLastCritieriaIndex &&
              isnotLastCriteriaOfLastSubLo &&
              hideCreateAssessmentCriteria
            ) {
              parentOffset = 0;
            }

            if (
              isLastCritieriaIndex &&
              isnotLastCriteriaOfLastSubLo &&
              !hideCreateAssessmentCriteria
            ) {
              parentOffset = 72;
              actionOffset = 72;
            }

            if (isLastCriteriaOfLastSubLoOfUltimateLo) {
              this.$set(this.offset, 'main', parentOffset);
            }

            this.$set(
              this.additionalOffset[`parent_${parentIndex}`],
              targetCriteriaIndex,
              offset + actionOffset
            );

            if (isActive !== undefined) {
              this.$set(this.activeState, `parent_${parentIndex}_${index}`, isActive);
            }
            // }
          }
        }
      };

      if (hideCreateAssessmentCriteria && hideAssessmentCriteria) {
        return node;
      } else {
        let items = [node];

        if (!hideAssessmentCriteria) {
          const assessments = this.extractAssessment(criterion, parentIndex, isObservedOffset);

          items = items.concat(assessments);
        }

        if (!hideCreateAssessmentCriteria) {
          items.push({
            component: CriteriaSubTree,
            componentProps: {
              sectionId,
              criterion,
              disabled: disabled,
              hideCreateAssessmentCriteria
            },
            icon: {
              branch: true
            }
          });
        }

        return {
          component: BaseTree,
          componentProps: {
            class: {
              'is-branch': true,
              criteria: true,
              'criteria__sub-lo': true
            },
            items,
            offset: this.offset,
            additionalOffset: this.additionalOffset,
            index: `child_${parentIndex}_${index}`
          },
          icon: {
            branch: true
          }
        };
      }
    },

    extractAssessment(criterion, parentIndex, isObservedOffset = false) {
      const {
        grantCertMode,
        mapCriterionPost,
        hideCreateUltimateLo,
        hideCreateCriteriaUltimateLo,
        hideCreateCriteriaSubLo,
        hideShift,
        hideSetting,
        hideDescription,
        disabled
      } = this;

      let assessments = Post.query()
        .where(
          ({ is_submission = false, criterion_ids = [] }) =>
            is_submission && criterion_ids.includes(criterion.id)
        )
        .get();

      const maxAssessmentIndex = assessments.length - 1;

      return assessments.map((assessment, assessmentIndex) => {
        const targetAssessmentIndex =
          this.additionalIndices[
            `parent_${parentIndex}_criterion_${criterion.id}_assessment_${assessment.id}`
          ];

        return {
          index: assessmentIndex,
          title: 'Assessment',
          subTitle: assessment.title,
          description: `
            <p class="text__assessment-description text-pre-wrap">${assessment.description}</p>
          `,
          itemClass: {
            'card__assessment-card': true
          },
          titleClass: {
            'text-muted': grantCertMode
              ? mapCriterionPost &&
                mapCriterionPost[`${criterion.id}_${assessment.id}`] &&
                mapCriterionPost[`${criterion.id}_${assessment.id}`].pass
                ? false
                : true
              : false
          },
          subTitleClass: {
            'text__assessment-title': true,
            'text-muted': grantCertMode
              ? mapCriterionPost &&
                mapCriterionPost[`${criterion.id}_${assessment.id}`] &&
                mapCriterionPost[`${criterion.id}_${assessment.id}`].pass
                ? false
                : true
              : false
          },
          descriptionClass: {
            'ml-3': true
          },
          togglerLabel: 'description',
          togglerActiveClass: 'button__hide-description',
          togglerInActiveClass: 'button__show-description',
          hideShift,
          hideSetting,
          hideDescription,
          isObservedOffset,
          parentIndex: `parent_${parentIndex}`,
          activeState: this.activeState,
          disableShiftUp: disabled || assessmentIndex === 0,
          disableShiftDown: disabled || assessmentIndex === maxAssessmentIndex,
          disabled,
          icon: grantCertMode
            ? {
                branch: true,
                faIcon:
                  mapCriterionPost &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`] &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`].pass
                    ? 'check-circle'
                    : 'clock',
                color:
                  mapCriterionPost &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`] &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`].pass
                    ? 'success'
                    : 'warning',
                variant:
                  mapCriterionPost &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`] &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`].pass
                    ? 'success'
                    : 'warning',
                className:
                  mapCriterionPost &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`] &&
                  mapCriterionPost[`${criterion.id}_${assessment.id}`].pass
                    ? {
                        'bg-50-icon__success': true
                      }
                    : { 'bg-50-icon__warning': true }
              }
            : {
                branch: true,
                text: 'A',
                variant: 'info'
              },
          on: {
            'update:state': ({ offset, isActive } = {}) => {
              if (
                (hideCreateUltimateLo && hideCreateCriteriaUltimateLo) ||
                hideCreateCriteriaSubLo
              ) {
                this.$set(
                  this.additionalOffset[`parent_${parentIndex}`],
                  targetAssessmentIndex,
                  offset
                );

                if (isActive !== undefined) {
                  this.$set(this.activeState, `parent_${parentIndex}_${assessmentIndex}`, isActive);
                }
              }
            }
          }
        };
      });
    },

    extractSubLearningOutcomeTree(
      subLearningOutcome,
      learningOutcome,
      children = [],
      index,
      maxIndex
    ) {
      if (this.showOnlyHasCriteria && !children.length) return;

      const self = this;

      const {
        disabled,
        hideShift,
        hideSetting,
        hideCreateUltimateLo,
        hideCreateCriteriaUltimateLo,
        hideCreateCriteriaSubLo,
        hideDescription,
        grantCertMode,
        criteria
      } = this;

      let subCriteria = [];
      let isSubLearningOutcomePass = false;
      let isObservedOffset =
        (index === maxIndex && hideCreateUltimateLo && hideCreateCriteriaUltimateLo) ||
        (index !== maxIndex &&
          children.length === 0 &&
          hideCreateUltimateLo &&
          hideCreateCriteriaUltimateLo);

      if (children.length) {
        const maxChildrenIndex = children.length - 1;

        children.forEach((node, childIndex) => {
          const criterion = Criteria.find(node.id);

          const subCriterionItem = this.extractSubLoCriteriaTree(
            criterion,
            childIndex,
            maxChildrenIndex,
            index
          );

          if (subCriterionItem) {
            subCriteria.push(subCriterionItem);
          }
        });

        if (criteria) {
          isSubLearningOutcomePass = children.every(
            (c) => criteria[c.id] && criteria[c.id].pass === true
          );
        }
      }

      const items = [
        {
          title: 'Sub learning outcome',
          subTitle: subLearningOutcome.title,
          description: subLearningOutcome.description,
          itemClass: {
            'card__sub-lo-card': true
          },
          titleClass: {
            'text-muted': grantCertMode ? !isSubLearningOutcomePass : false
          },
          subTitleClass: {
            'text__sub-lo-title': true,
            'text-muted': grantCertMode ? !isSubLearningOutcomePass : false
          },
          descriptionClass: {
            'text__sub-lo-description': true,
            'ql-editor ql-editor--display': true
          },
          togglerLabel: 'description',
          togglerActiveClass: 'button__hide-description',
          togglerInActiveClass: 'button__show-description',
          hideShift,
          hideSetting,
          hideDescription,
          disableShiftUp: disabled || index === 0,
          disableShiftDown: disabled || index === maxIndex,
          isObservedOffset,
          disabled,
          icon: grantCertMode
            ? {
                color: isSubLearningOutcomePass ? 'success' : 'warning',
                variant: isSubLearningOutcomePass ? 'success' : 'warning',
                faIcon: isSubLearningOutcomePass ? 'check-circle' : 'clock',
                className: isSubLearningOutcomePass
                  ? {
                      'bg-50-icon__success': true
                    }
                  : { 'bg-50-icon__warning': true }
              }
            : {
                variant: 'first',
                text: 'S'
              },
          on: {
            edit() {
              if (subLearningOutcome) {
                self.subLearningOutcomeData = subLearningOutcome;
                self.showModalSubLearningOutcome = true;
              }
            },
            delete() {
              if (subLearningOutcome) {
                self.subLearningOutcomeData = subLearningOutcome;
                self.showModalDeleteSubLearningOutcome = true;
              }
            },

            'shift:up': () => {
              // on shift up sub-learning outcome
              self.shiftUp(index);
            },

            'shift:down': () => {
              // on shift down sub-learning outcome
              self.shiftDown(index);
            },

            'update:state': ({ offset, isActive } = {}) => {
              this.$set(this.offset, `parent_${index}`, offset);

              if (this.index === this.lastParentIndex) {
                this.$set(this.offset, 'main', offset);
              }

              if (isActive !== undefined) {
                this.$set(this.activeState, `parent_${index}`, isActive);
              }
            }
          }
        },
        ...subCriteria
      ];

      if (!hideCreateCriteriaSubLo) {
        items.push({
          component: SubLearningOutcomeSubTree,
          componentProps: {
            ultimateLearningOutcome: learningOutcome,
            subLearningOutcome: subLearningOutcome,
            disabled: disabled,
            hideCreateCriteriaSubLo
          },
          icon: {
            branch: true
          }
        });
      }

      return {
        component: BaseTree,
        itemClass: { 'timeline-item__sub-lo': true },
        componentProps: {
          class: { 'is-branch': true, 'sub-lo': true },
          items,
          offset: this.offset,
          additionalOffset: this.additionalOffset,
          index: `parent_${index}`
        },
        icon: {
          branch: true
        }
      };
    },

    extractUltimateLearningOutcomeTree(learningOutcome) {
      const {
          $router,
          $route,
          disabled,
          hideShift,
          hideSetting,
          hideCreateUltimateLo,
          hideCreateCriteriaUltimateLo,
          modalMode,
          hideDescription,
          grantCertMode,
          isSubmissionPass
        } = this,
        self = this;
      let items = [];

      items.push({
        subTitle: '',
        description: learningOutcome.description,
        subTitleClass: {
          'text__ultimate-lo-title': true
        },
        descriptionClass: {
          'text__ultimate-lo-description': true,
          'ql-editor ql-editor--display': true
        },
        togglerLabel: 'description',
        togglerActiveClass: 'button__hide-description',
        togglerInActiveClass: 'button__show-description',
        title: 'Competency',
        icon: {
          variant: 'primary',
          text: 'U'
        },
        deleteable: false,
        hideShift,
        hideSetting,
        hideDescription,
        disableShiftUp: true,
        disableShiftDown: true,
        disabled,
        on: {
          edit() {
            if (modalMode) {
              self.showModalUltimateLearningOutcome = true;
            } else {
              $router.push({
                name: 'design-planning/ultimate-learning-outcome/edit',
                params: {
                  learningUnitId: learningOutcome.learning_unit_id,
                  id: learningOutcome.id
                },
                query: {
                  previousPath: $route.fullPath
                }
              });
            }
          }
        }
      });

      const { filteredOrder = [] } = this;

      const maxIndex = filteredOrder.length ? filteredOrder.length - 1 : null;

      this.lastParentIndex = maxIndex;

      filteredOrder.forEach((node, index) => {
        const subItem = this.extractRootNode(learningOutcome, node, index, maxIndex);

        if (subItem) {
          items.push(subItem);
        }
      });

      if (grantCertMode) {
        items[0].icon = isSubmissionPass
          ? {
              variant: 'success',
              faIcon: 'check-circle',
              color: 'success',
              className: {
                'bg-50-icon__success': true
              }
            }
          : {
              variant: 'warning',
              faIcon: 'clock',
              color: 'warning',
              className: {
                'bg-50-icon__warning': true
              }
            };

        items[0].titleClass = { 'text-muted': !isSubmissionPass };
        items[0].subTitleClass = {
          ...items[0].subTitleClass,
          'text-muted': !isSubmissionPass
        };
      }

      if (!hideCreateUltimateLo || !hideCreateCriteriaUltimateLo) {
        items.push({
          component: UltimateLearningOutcomeSubTree,
          componentProps: {
            ultimateLearningOutcome: learningOutcome,
            disabled,
            hideCreateUltimateLo,
            hideCreateCriteriaUltimateLo
          },
          icon: {
            branch: true
          }
        });
      }

      return items.filter(Boolean);
    },

    extractRootNode(learningOutcome, { id, model, children = [] } = {}, index) {
      const isLastIndex = index === this.lastParentIndex;
      const { hideCreateUltimateLo, hideCreateCriteriaUltimateLo } = this;
      const isObservedOffset = isLastIndex && hideCreateUltimateLo && hideCreateCriteriaUltimateLo;

      const shouldInitializeAdditionalOffset = !this.additionalOffset[`parent_${index}`];

      let item;

      if (!this.offset[`parent_${index}`]) {
        this.$set(this.offset, `parent_${index}`, 0);
      }

      if (shouldInitializeAdditionalOffset) {
        this.$set(this.additionalOffset, `parent_${index}`, []);
      }

      if (model === 'learning-outcomes') {
        const subLearningOutcome = LearningOutcome.query().with('criteria').find(id);

        if (subLearningOutcome) {
          // if extract child node was called on the root level
          if (shouldInitializeAdditionalOffset) {
            const { criterion_ids = [] } = subLearningOutcome;

            criterion_ids.forEach((criterion_id) => {
              this.additionalOffset[`parent_${index}`].push(0);

              this.$set(
                this.additionalIndices,
                `parent_${index}_criteria_${criterion_id}`,
                this.additionalOffset[`parent_${index}`].length - 1
              );

              let criteriaAssessments = Post.query()
                .where(
                  ({ is_submission = false, criterion_ids = [] }) =>
                    is_submission && criterion_ids.includes(criterion_id)
                )
                .get();

              if (criteriaAssessments.length) {
                criteriaAssessments.forEach((criteriaAssessment) => {
                  this.additionalOffset[`parent_${index}`].push(0);

                  this.$set(
                    this.additionalIndices,
                    `parent_${index}_criterion_${criterion_id}_assessment_${criteriaAssessment.id}`,
                    this.additionalOffset[`parent_${index}`].length - 1
                  );
                });
              }
            });
          }

          item = this.extractSubLearningOutcomeTree(
            subLearningOutcome,
            learningOutcome,
            children,
            index,
            this.lastParentIndex
          );
        }
      }

      if (model === 'criterias') {
        const criterion = Criteria.find(id);

        // if extract child node was called on the root level
        if (shouldInitializeAdditionalOffset) {
          // this.additionalOffset[`parent_${index}`].push(0);

          // this.$set(
          //   this.additionalIndices,
          //   `parent_${index}_criteria_${criterion.id}`,
          //   this.additionalOffset[`parent_${index}`].length - 1
          // );

          let assessments = Post.query()
            .where(
              ({ is_submission = false, criterion_ids = [] }) =>
                is_submission && criterion_ids.includes(criterion.id)
            )
            .get();

          if (assessments.length) {
            assessments.forEach((assessment) => {
              this.additionalOffset[`parent_${index}`].push(0);

              this.$set(
                this.additionalIndices,
                `parent_${index}_criterion_${criterion.id}_assessment_${assessment.id}`,
                this.additionalOffset[`parent_${index}`].length - 1
              );
            });
          }
        }

        if (criterion) {
          item = this.extractRootCriteriaTree(criterion, index);
        }
      }

      if (isObservedOffset) {
        this.additionalOffset['main'] = this.additionalOffset[`parent_${index}`];
      }

      return item;
    },

    async shiftUp(index, subIndex = null) {
      return await this.shift(index, -1, subIndex);
    },

    async shiftDown(index, subIndex = null) {
      return await this.shift(index, 1, subIndex);
    },

    async shift(index, step = 1, subIndex = null) {
      const { id: ultimateLearningOutcomeId } = this.learningOutcome;

      const { properties = {}, order = [] } = this;

      if (subIndex !== null) {
        const { children = [] } = order[index];

        const item = children[subIndex];

        const swappedItem = children[subIndex + step];

        children.splice(subIndex, 1, swappedItem);

        children.splice(subIndex + step, 1, item);

        this.$set(order[index], 'children', children);
      } else {
        const item = order[index];

        const swappedItem = order[index + step];

        order.splice(index, 1, swappedItem);

        order.splice(index + step, 1, item);
      }

      LearningOutcome.update({
        where: ultimateLearningOutcomeId,
        data: { properties: JSON.stringify({ ...properties, order }) }
      });

      await LearningOutcome.api().updateProperties(ultimateLearningOutcomeId, {
        ...properties,
        order
      });
    },

    onCriteriaDeleted(criteria_id) {
      this.$emit('onCriteriaDeleted', criteria_id);
    },

    onSubLearningOutcomeDeleted(criteria_ids) {
      this.$emit('onSubLearningOutcomeDeleted', criteria_ids);
    },

    async onCriteriaUpdated() {
      this.showModalCriteria = false;
      this.criteriaData = null;
    },

    onUltimateLearningOutcomeUpdated() {
      this.showModalUltimateLearningOutcome = false;
    },

    onSubLearningOutcomeUpdated() {
      this.showModalSubLearningOutcome = false;
      this.subLearningOutcomeData = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.tree__learning-outcome {
  margin-bottom: 5rem;
}
</style>

<style lang="scss">
.timeline-list {
  &.is-branch {
    padding-top: 0;
    position: relative;
    left: -5px;
  }
}

.bg-50-icon {
  &__success {
    background-color: #e5f9ed !important;
  }

  &__warning {
    background-color: #fffbf2 !important;
  }
}
</style>
